import {Pipe, PipeTransform} from "@angular/core";
import {OPTIMIZE_STATUSES} from "../_maps/optimize-statuses";

@Pipe({name: "optimizationStatus"})
export class OptimizationStatusPipe implements PipeTransform {
  transform(status: string): any {
    return OPTIMIZE_STATUSES[status] || '';
  }
}
